<div class="trainer-invite">
  @if (isTrainingNotFound) {
    <app-invalid-invitation></app-invalid-invitation>
  } @else if (training) {
    <div class="trainer-invite-card">
      <div class="training-location-image">
        <img [src]="training.logoUrl" title="Logo"/>
      </div>
      <div class="trainer-invite-card-title">
        {{ "TRAINER-DETAILS.OVERVIEW.TITLE" | translate }}
      </div>
      @if(!isInvalidInvitation && training.currentTrainer){
        <div class="trainer-invite-card-subtitle">
          {{ "TRAINER-DETAILS.OVERVIEW.SUBTITLE" | translate }}
          {{ training.currentTrainer.firstName + ' ' +  training.currentTrainer.lastName}}
        </div>
      }

      @if(isInvalidInvitation) {
        <app-invalid-invitation
        ></app-invalid-invitation>
      } @else {
        <app-panel>
          <div class="training-image-container">
            <img
              class="training-image"
              [src]="training.imageFile?.fileUrl"
              appTrainingImageFallback
              title="Training"
            />
          </div>
          <div class="training-name">{{ training.name }}</div>
          <div class="training-description">{{ training.description }}</div>
          <div class="training-info">
            <div class="trainer-container">
              <div class="row gy-2">
                @for (trainer of trainers; track trainer.id) {
                  <div class="col-12 col-sm-6 col-md-auto">
                    <app-trainer-card
                      [trainer]="trainer"
                      [maxNameLength]="20"
                      fontSize="16px"
                      avatarSize="35px"
                      fontColor="black"
                    ></app-trainer-card>
                  </div>
                }
              </div>
            </div>
            <div class="training-stats">
              <div *ngIf="training.iddTime" class="training-stats-item">
                {{ "COMMON.FIELDS.IDD-TIME-CREDIT" | translate }}:
                {{ durationString }}
              </div>
            </div>
          </div>
          <div class="training-widgets">
            <div class="training-widget-item">
              <div class="training-widget-badge">
                <i class="dx-icon dx-svg-icon" [innerHTML]="getCalendarIcon()"></i>
                {{ "COMMON.DATE" | translate }}:
              </div>
              <div class="training-widget-value">
                <div
                  *ngFor="let date of training.dates"
                  class="training-dates-block"
                >
                  <div class="training-dates-block-date">
                    {{
                      training.dates[0]
                        | trainingDate : translateService.currentLang
                    }}
                  </div>
                  <div *ngIf="translateService.currentLang == 'en'">
                    {{ training.dates[0].start | date : "hh:mm a" }} -
                    {{ training.dates[0].end | date : "hh:mm a" }}
                  </div>
                  <div *ngIf="translateService.currentLang == 'de'">
                    {{ training.dates[0].start | date : "HH:mm" }} -
                    {{ training.dates[0].end | date : "HH:mm" }}
                  </div>
                </div>
              </div>
            </div>
            <div class="training-widget-item">
              <div class="training-widget-badge">
                <i class="dx-icon-map dx-svg-icon"></i>
                {{ "COMMON.FIELDS.LOCATION" | translate }}:
              </div>
              <div class="training-widget-value">
                <span
                  *ngIf="training.locationType == TrainingLocationType.GoToWebinar"
                >
                  GoTo Webinar
                </span>
                <span *ngIf="training.locationType == TrainingLocationType.Webex">
                  Webex
                </span>
                <span *ngIf="training.locationType == TrainingLocationType.MsTeamsWebinar">
                  Teams Webinar
                </span>
                <span *ngIf="training.locationType == TrainingLocationType.MsTeamsMeetings">
                  Teams Meeting
                </span>
                <span *ngIf="training.locationType == TrainingLocationType.Zoom">
                  Zoom Webinar
                </span>
                <span *ngIf="training.locationType == TrainingLocationType.Web">
                  {{ "MY-INVITATION.ONLINE-MEETING" | translate }}
                </span>
                <span
                  *ngIf="
                    training.locationType != TrainingLocationType.GoToWebinar &&
                    training.locationType != TrainingLocationType.Webex &&
                    training.locationType != TrainingLocationType.MsTeamsWebinar &&
                    training.locationType != TrainingLocationType.MsTeamsMeetings &&
                    training.locationType != TrainingLocationType.Zoom &&
                    training.locationType != TrainingLocationType.Web
                  "
                >
                  {{ training.location }}
                </span>
                <div class="training-location-details">
                  <div class="training-location-details-title">
                    {{ "COMMON.FIELDS.LOCATION-DETAILS" | translate }}
                  </div>
                  <span
                    *ngIf="training.locationType == TrainingLocationType.Address"
                    >{{ training.locationSuffix }}</span
                  >
                  @if(!isDeclined) {
                    @if (
                      training.locationType != TrainingLocationType.Address &&
                      training.locationType != TrainingLocationType.Web &&
                      !accessToken
                    ) {
                      @if (training.locationSuffix.startsWith('https://')) {
                        <a
                          [attr.href]="training.locationSuffix"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ training.locationSuffix }}
                        </a>
                      } @else {
                        <span>{{ training.locationSuffix }}</span>
                      }
                    }
                    @if (training.locationType === TrainingLocationType.Web) {
                      @if (training.locationSuffix.startsWith('https://')) {
                        <a
                          [attr.href]="training.locationSuffix"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ training.locationSuffix }}
                        </a>
                      } @else {
                        <span>{{ training.locationSuffix }}</span>
                      }
                    }
                    @if (
                      training.locationType != TrainingLocationType.Address &&
                      training.locationType != TrainingLocationType.Web &&
                      accessToken &&
                      training.joinUrl
                    ) {
                      <a
                        [attr.href]="training.joinUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ training.joinUrl }}
                      </a>
                    }
                  }
                  <span
                    *ngIf="
                      training.locationType == TrainingLocationType.Web &&
                      isDeclined
                    "
                    >{{ "MY-INVITATION.ACCESS-LINK-INFO2" | translate }}
                  </span>
                  <span
                    *ngIf="
                      training.locationType != TrainingLocationType.Address &&
                      training.locationType != TrainingLocationType.Web &&
                      isDeclined &&
                      !accessToken
                    "
                    >{{ "MY-INVITATION.ACCESS-LINK-INFO" | translate }}
                  </span>
                  <span
                    *ngIf="
                      training.locationType != TrainingLocationType.Address &&
                      training.locationType != TrainingLocationType.Web &&
                      accessToken &&
                      !training.joinUrl
                    "
                    >{{ "MY-INVITATION.ACCESS-LINK-INFO" | translate }}</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="training-cta-section">
            @if(!isDeclined) {
              <div class="training-button-section">
                <dx-button
                  class="cta-btn"
                  [text]="'TRAINER-DETAILS.OPEN-TRAINING' | translate"
                  type="normal"
                  (click)="openTraining()"
                >
                </dx-button>
                <dx-button
                  class="cta-btn"
                  [text]="'TRAINER-DETAILS.SAVE-TO-CALENDAR' | translate"
                  type="normal"
                  (click)="isAddedToCalendar ? onDownloadIcsClick() : saveToCalendar()"
                >
                </dx-button>
                <dx-button
                  class="cta-btn"
                  [text]="'TRAINER-DETAILS.DECLINE-INVITATION' | translate"
                  type="danger"
                  (click)="openDeclineTrainingConfirmationModal()"
                >
                </dx-button>
              </div>
            }
            <div class="training-info" *ngIf="training.status === 1">
              {{ "MY-INVITATION.OLD-EVENT" | translate }}
            </div>
            <div class="training-info" *ngIf="training.status === 2">
              {{ "MY-INVITATION.EVENT-BOOKED" | translate }}
            </div>
            <div class="training-info" *ngIf="training.status === 3">
              {{ "MY-INVITATION.EVENT-CANCELLED" | translate }}
            </div>
            @if(isDeclined){
              <div class="training-info">
                {{ "TRAINER-DETAILS.DECLINED-PARTICIPATION-TEXT" | translate }}
              </div>
            }
          </div>
          @if(training.descriptionExtended) {
            <div class="training-section">
              <div class="training-section-title">
                {{ "COMMON.FIELDS.DESCRIPTION" | translate }}
              </div>
              <dx-html-editor
                label=""
                [(value)]="training.descriptionExtended"
                [readOnly]="true"
              >
              </dx-html-editor>
            </div>
          }
          <div class="training-section training-section-location">
            <div *ngIf="training.locationType == TrainingLocationType.Address">
              <ng-container *ngIf="training.latitude && training.longitude">
                <app-google-maps
                  class="my-3"
                  [location]="location"
                ></app-google-maps>
              </ng-container>
            </div>
            <div
              *ngIf="training.locationType == TrainingLocationType.GoToWebinar"
              class="training-location-image-container"
            >
              <img
                class="training-location-image"
                src="assets/img/gotowebinar-logo.jpg"
                title="Location"
              />
            </div>
            <div
              *ngIf="training.locationType == TrainingLocationType.Webex"
              class="training-location-image-container"
            >
              <img
                class="training-location-image"
                src="assets/img/webex-logo.jpg"
                title="Location"
              />
            </div>
          </div>
        </app-panel>
      }
    </div>
  }
</div>

@if(showDeclineInvitationModal){
  <app-decline-trainer-invitation-dialog
    [(showModal)]="showDeclineInvitationModal"
    (decline)="decline()"
  ></app-decline-trainer-invitation-dialog>
}